import { FC } from 'react';
import {
  ChevronIcon,
  SearchInput,
  SearchWrapper,
  SelectInnerWrapper,
  SelectTextWrapper,
  SelectWrapper,
  TypeSelect,
  Wrapper,
  WrapperInTypeSelect,
} from './fias-search-mock-input.styled';

interface Props {
  isDisabled: boolean;
  isActive: boolean;
  error?: string;
  /** Без селекта типа: фиксированный вариант «Дома», как в FiasSearch. */
  withoutHouseGroups?: boolean;
}

export const FiasSearchMockInput: FC<Props> = ({
  isDisabled,
  isActive,
  error,
  withoutHouseGroups = false,
}) => {
  return (
    <Wrapper isDisabled={isDisabled}>
      <SearchWrapper
        isActive={isActive}
        isDisabled={isDisabled}
        invalid={Boolean(error)}
      >
        <TypeSelect isFixed={withoutHouseGroups}>
          <WrapperInTypeSelect>
            <SelectTextWrapper>Дома</SelectTextWrapper>
            {!withoutHouseGroups && <ChevronIcon />}
          </WrapperInTypeSelect>
        </TypeSelect>
        <SelectWrapper>
          <SelectInnerWrapper>
            <SearchInput placeholder="Выберите дома" />
          </SelectInnerWrapper>
        </SelectWrapper>
      </SearchWrapper>
    </Wrapper>
  );
};
